import React from "react";
// common-ui theme provider and default theme
import {
  ThemeProvider,
  lightTheme,
  // defaultTheme,
  // , defaultTheme
} from "@common-ui/ui";
// Set up redux store
// import { createStore, applyMiddleware } from "redux";
import { Provider, connect } from "react-redux";
// import { composeWithDevTools } from "redux-devtools-extension";

import { configureStore } from "@reduxjs/toolkit";

import { Amplify } from "aws-amplify";

import RootReducer from "./reducers";

// import thunk from "redux-thunk";
import { Root } from "./router";

import { config } from "./configs";
import thunk from "redux-thunk";
import { ModalProvider } from "./components/BrowserAlert/modalContext";
Amplify.configure(config);

// export const store = createStore(
//   RootReducer,
//   composeWithDevTools(applyMiddleware(thunk))
// );

export const store = configureStore({
  reducer: RootReducer,
  middleware: [thunk],
});

const mapStateFromProps = (state) => ({
  organization: state.organization,
});

const RootWithState = connect(mapStateFromProps, {})(Root);

function App() {
  return (
    <ModalProvider>
    <Provider store={store}>
      <ThemeProvider theme={lightTheme}>
        <RootWithState />
      </ThemeProvider>
    </Provider>
    </ModalProvider>
    
  );
}

export default App;
